// extracted by mini-css-extract-plugin
export var centerText = "_4j-8";
export var container = "_4j-0";
export var doughnutContainer = "_4j-7";
export var legend = "_4j-a";
export var legendItemColorDisplay = "_4j-b";
export var legendItemLabel = "_4j-d";
export var legendItemValue = "_4j-c";
export var lg = "_4j-5";
export var maxWidth = "_4j-9";
export var md = "_4j-4";
export var responsive = "_4j-6";
export var sm = "_4j-3";
export var xs = "_4j-2";
export var xxs = "_4j-1";